import React, { useRef, useState } from 'react'
import classes from './PopOver.module.css'
import Popover from 'react-bootstrap/Popover';
import { Overlay } from 'react-bootstrap';

const PopOver = props => {
    const [show, setShow] = useState(false);
    const [target, setTarget] = useState(null);
    const ref = useRef(null);
  
    const handleClick = (event) => {
      setShow(!show);
      setTarget(event.target);
    };
    const handleClick1 = () => {
        setShow(!show);
        setTarget(null)
      };
  return (
    <div ref={ref}>
      <span onClick={handleClick}>{props.triggerBTN}</span>
      <Overlay
        show={show}
        target={target}
        placement="bottom"
        container={ref}
        //containerPadding={20}
      >
        <Popover id="popover-contained popover-positioned-bototm">
          <Popover.Body>
            <div className={classes.header}>
              <h6>{props.headerName}</h6>
              <i
                className={`bx bx-x ${classes.close}`}
                onClick={handleClick1}
              ></i>
            </div>
            {props.children}
          </Popover.Body>
        </Popover>
      </Overlay>
    </div>
  );
}

export default PopOver